import React from 'react';
import { Container, Row, Col, Carousel, Button } from 'react-bootstrap';
import './Merchandise.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Merchandise = () => {
  return (
    <Container>
      {/* Title & Description */}
      <div className="text-box-container">
        <h2 className="title">Our Merchandise</h2>
        <p className="subtitle">
          Our merchandise serves as an opportunity to represent the mission of Food for Thought. 
          All proceeds will be used to support our mission. If you are interested in purchasing 
          or have merchandise ideas, please contact Paul Selberg.
        </p>
      </div>

      {/* Centered Purchase Button */}
      <Row className="justify-content-center my-4">
        <Col xs={12} className="text-center">
          <Button
            variant="info"
            href="https://www.zeffy.com/en-US/ticketing/food-for-thoughts-shop"
            target="_blank"
            rel="noopener noreferrer"
            className="purchase-button"
          >
            <FontAwesomeIcon /> Purchase
          </Button>
        </Col>
      </Row>

      {/* Merchandise Carousels */}
      <Row className="carousel-container">
        <Col md={6} className="text-center">
          <Carousel>
            <Carousel.Item>
              <img src="../../../Images/ShirtFront.png" alt="First slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img src="../../../Images/ShirtBack.png" alt="Second slide" />
            </Carousel.Item>
          </Carousel>
        </Col>

        <Col md={6} className="text-center">
          <Carousel>
            <Carousel.Item>
              <img src="../../../Images/SweatshirtBlueFront.png" alt="First slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img src="../../../Images/SweatshirtBlueBack.png" alt="Second slide" />
            </Carousel.Item>
          </Carousel>
        </Col>
      </Row>
      <Row className="justify-content-center d-flex">
  <Col md={6} className="text-center">
    <Carousel>
      <Carousel.Item>
        <img src="../../../Images/SweatshirtFrontSoldOut.png" alt="First slide" className="img-fluid" />
      </Carousel.Item>
      <Carousel.Item>
        <img src="../../../Images/SweatshirtBackSoldOut.png" alt="Second slide" className="img-fluid" />
      </Carousel.Item>
    </Carousel>
  </Col>
   <Col md={6} className="text-center">
    <Carousel>
      <Carousel.Item>
        <img src="../../../Images/RedFront.png" alt="First slide" className="img-fluid" />
      </Carousel.Item>
      <Carousel.Item>
        <img src="../../../Images/RedBack.png" alt="Second slide" className="img-fluid" />
      </Carousel.Item>
    </Carousel>
  </Col>
</Row>

    </Container>
  );
};

export default Merchandise;
